import React from "react";
import ChatListBubble from "./ChatListBubble";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";

interface AllChatProps {
  setSelectedChatId: (id: string) => void;
  handleSelectChat: (id: string) => void;
  selectedChat: any;
  selectedChatId: string;
  searchQuery: string;
}

const AllChat: React.FC<AllChatProps> = ({
  handleSelectChat,
  selectedChatId,
  searchQuery,
}) => {
  const chatList = useSelector(
    (state: RootState) => state.whatsAppData.whatsappChatList
  ) as any;

  return (
    <div className="flex-1 overflow-y-auto">
      {chatList
        ?.filter((chat: any) => chat.receiver.includes(searchQuery))
        .map((chat: any, index: any) => (
          <ChatListBubble
            index={index}
            key={chat._id}
            chat={chat}
            handleSelectChat={handleSelectChat}
            selectedChatId={selectedChatId}
          />
        ))}
    </div>
  );
};
export default AllChat;
